import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToolsProvider } from '../../provider/tools/tools';
import { HttpClient } from '@angular/common/http';
import { BaseUrl } from '../../service/Configuration';

@Component({
  selector: 'app-pop-add-gasto',
  templateUrl: './pop-add-gasto.component.html',
  styleUrls: ['./pop-add-gasto.component.scss'],
})
export class PopAddGastoComponent implements OnInit {
selectTipo=''
selectCodigo:number
dias:number
gasto:number
tipo:any=[]
  constructor(private popoverCtrl:PopoverController, public tool:ToolsProvider, 
    private http:HttpClient) { }

  ngOnInit() {
    this.getList()
  }

  getList(){//CARGA LA LISTA DE LOS TIPOS DE GASTO
    this.tool.showLoader()
    this.http.get(BaseUrl+'api/getTipoGasto').subscribe((Response:any)=>{
      this.tipo = Response
      console.log(this.tipo);
      this.tool.hideLoader()
    },err=>{
      this.tool.hideLoader()
  
      var error = err.error;
      var error2 = err.message;
      if (error.type != undefined) {
        error = error2
      }
  
      this.tool.showAlert('ERROR',''+ 'Ha ocurrido un error<br>'+error)
    });
  }

  onChange(event){
      this.selectCodigo=event.detail.value
      
    }

    onInputTime(event, tipo: number){
      if(tipo==1){
        this.dias=event
      }else if(tipo == 2){
        this.gasto = event
      }
    }
  
    agregar(){
      if(this.dias === undefined && this.gasto === undefined){
        this.tool.showAlert('Mensaje','Campos vacios');
        return;
      }
      if(this.dias===undefined){
        this.tool.showAlert('Mensaje','Ingrese dias');
        return;
      }
      if(this.gasto === undefined){
        this.tool.showAlert('Mensaje','Ingrese gasto');
        return;
      }
      if(this.selectCodigo === undefined){
        this.tool.showAlert('Mensaje', 'Seleccionar gasto')
        return;
      }
      for(var x=0;x<this.tipo.length; x++){
        if(this.selectCodigo == this.tipo[x].Codigo){
            this.selectTipo=this.tipo[x].Tipo
        }
      }

      this.popoverCtrl.dismiss({'tipo':this.selectTipo,
                                'Codigo':this.selectCodigo,
                                'dias':this.dias,
                                'gasto':this.gasto})
    }
}
